export enum BUTTON_GROUP_TYPES {
  DEFAULT = 'default',
  SINGLE_SELECT = 'singleSelect',
  MULTI_SELECT = 'multiSelect',
}
